import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App.js';
import { setupPwaI18n } from './i18n/setup.js';
import { LANG_STORAGE_KEY } from './store/sessionStore.js';
import { captureTestToken } from './lib/testSession.js';
import { setupServiceWorkerAutoReload } from './lib/swUpdate.js';
import './index.css';

// Deve girare prima di qualunque chiamata API: sposta il token dalla querystring
// in sessionStorage e ripulisce la barra degli indirizzi.
captureTestToken();

setupServiceWorkerAutoReload();

function readPersistedLanguage(): 'it' | 'en' | 'fr' {
  try {
    const lang = localStorage.getItem(LANG_STORAGE_KEY);
    return lang === 'en' || lang === 'fr' ? lang : 'it';
  } catch {
    return 'it';
  }
}

setupPwaI18n(readPersistedLanguage()).then(i18n => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </React.StrictMode>
  );
});
